import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_Pcp = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_Pcp' className='file-pdf-document'>
            <div className='file-template'>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Does the Client have a current PCP?</span>
                            <input type='radio' id='rb_1_1' name='rb_1' className='add-only' value='1' /> Yes&nbsp;
                            <input type='radio' id='rb_1_2' name='rb_1' className='add-only' value='2' /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    Dear Dr. <input type='text' id='txt_2' name='txt_2' className='add-only w-375 custom-add-only' />
                    &nbsp; Phone#:<input type='text' id='txt_3' name='txt_3' className='add-only w-200 custom-add-only' />
                    &nbsp; Fax#:<input type='text' id='txt_4' name='txt_4' className='add-only w-200 custom-add-only' /> <br />
                    This letter is to inform you that <input type='text' id='txt_5' name='txt_5' className='add-only w-200 custom-add-only' />
                    &nbsp; DOB:<input type='date' id='txt_6' name='txt_6' className='add-only w-200 custom-add-only' /> is currently
                    receiving the following services at our facility:<br />
                    <input type='checkbox' id='cb_7' name='cb_7' className='add-only' value='1' /> Targeted Case Management <br />
                    <input type='checkbox' id='cb_8' name='cb_8' className='add-only' value='1' /> Individual and Family Therapy <br />
                    <input type='checkbox' id='cb_9' name='cb_9' className='add-only' value='1' /> Psychiatric Evaluation <br />
                    <input type='checkbox' id='cb_10' name='cb_10' className='add-only' value='1' /> Medication Management <br />
                    <input type='checkbox' id='cb_11' name='cb_11' className='add-only' value='1' /> Psychosocial Rehabilitation <br />
                    <input type='checkbox' id='cb_12' name='cb_12' className='add-only' value='1' /> Therapeutic Behavioral Onsite
                    Services (In Home/School Based Services)<br />
                    <input type='checkbox' id='cb_13' name='cb_13' className='add-only' value='1' /> Other Services:(specify)
                    <input type='text' id='txt_14' name='txt_14' className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of Admission:</span>
                            <input type='text' id='txt_15' name='txt_15' className='dd dpc' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Diagnosis:</span>
                            <input type='text' id='txt_16' name='txt_16' className='dd formTextbox' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Medications:</span>
                    <textarea id='txt_17' name='txt_17' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>*Is there a signed Private Health Information (PHI) Consent for Release Form
                                for this PCP?</span>
                            <input type='radio' id='rb_18_1' name='rb_18' className='add-only' value='1' /> Yes&nbsp;
                            <input type='radio' id='rb_18_2' name='rb_18' className='add-only' value='2' /> No
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    We will notify you of all psychiatric hospitalizations and discharges, as well and keep you informed of the
                    curent treatment plan, and any changes to the treatment plan as they occur. If you have any questions,
                    please contact us at the number provided on this form. If this client is not recieving services at your
                    office please notify us as possible. We really appreciate your coorporation and attention to this request.
                </p>


            </div>
        </form>

    )
}











